const tokenData: Record<string, { fullName: string, name: string }> = {
  ADA: {
    fullName: "Cardano",
    name: "ADA"
  },
  APE: {
    fullName: "ApeCoin",
    name: "APE"
  },
  APT: {
    fullName: "Aptos",
    name: "APT"
  },
  ARB: {
    fullName: "Arbitrum",
    name: "ARB"
  },
  ATOM: {
    fullName: "Cosmos",
    name: "ATOM"
  },
  AVAX: {
    fullName: "Avalanche",
    name: "AVAX"
  },
  BASE: {
    fullName: "Basecoin",
    name: "BASE"
  },
  BLUR: {
    fullName: "Blur",
    name: "BLUR"
  },
  BTC: {
    fullName: "Bitcoin",
    name: "BTC"
  },
  CANTO: {
    fullName: "Canto",
    name: "CANTO"
  },
  COMP: {
    fullName: "Compound",
    name: "COMP"
  },
  CRO: {
    fullName: "Cronos",
    name: "CRO"
  },
  CRV: {
    fullName: "Curve DAO",
    name: "CRV"
  },
  DOT: {
    fullName: "Polkadot",
    name: "DOT"
  },
  ETH: {
    fullName: "Ethereum",
    name: "ETH"
  },
  FTM: {
    fullName: "Fantom",
    name: "FTM"
  },
  FUSE: {
    fullName: "Fuse",
    name: "FUSE"
  },
  GLMR: {
    fullName: "Moonbeam",
    name: "GLMR"
  },
  ICP: {
    fullName: "Internet Computer",
    name: "ICP"
  },
  KAVA: {
    fullName: "Kava",
    name: "KAVA"
  },
  LDO: {
    fullName: "Lido",
    name: "LDO"
  },
  LINK: {
    fullName: "Chainlink",
    name: "LINK"
  },
  MATIC: {
    fullName: "Polygon",
    name: "MATIC"
  },
  METIS: {
    fullName: "Metis",
    name: "METIS"
  },
  MKR: {
    fullName: "Maker",
    name: "MKR"
  },
  MNT: {
    fullName: "Mantle",
    name: "MNT"
  },
  MOVR: {
    fullName: "Moonriver",
    name: "MOVR"
  },
  NEAR: {
    fullName: "Near Protocol",
    name: "NEAR"
  },
  OP: {
    fullName: "Optimism",
    name: "OP"
  },
  PEPE: {
    fullName: "Pepe",
    name: "PEPE"
  },
  REAL: {
    fullName: "Real",
    name: "REAL"
  },
  SCRL: {
    fullName: "Scroll",
    name: "SCRL"
  },
  SEI: {
    fullName: "Sei",
    name: "SEI"
  },
  SNX: {
    fullName: "Synthetix",
    name: "SNX"
  },
  SOL: {
    fullName: "Solana",
    name: "SOL"
  },
  SUI: {
    fullName: "Sui",
    name: "SUI"
  },
  TRX: {
    fullName: "Tron",
    name: "TRX"
  },
  UNI: {
    fullName: "Uniswap",
    name: "UNI"
  },
  USDC: {
    fullName: "USDC",
    name: "USDC"
  },
  USDT: {
    fullName: "Tether",
    name: "USDT"
  },
  WLD: {
    fullName: "Worldcoin",
    name: "WLD"
  },
  XLM: {
    fullName: "Stellar",
    name: "XLM"
  },
  XRP: {
    fullName: "XRP",
    name: "XRP"
  },
  ZK: {
    fullName: "zkSync Era",
    name: "zkSync"
  },
  USD: {
    fullName: "US Dollar",
    name: "USD"
  },
  CAD: {
    fullName: "Canadian Dollar",
    name: "CAD"
  },
}

export function switchToken(tokenValue?: string, returnType: 'image' | 'fullName' | 'name' = "fullName") {
  const token = tokenValue ? tokenData[tokenValue] : null
  const imageSrc = tokenValue?.toLowerCase();

  if (!token) return returnType === 'image' ? null : 'N/A'

  switch (returnType) {
    case 'image':
      return <img src={require(`../assets/images/tokens/icn-${imageSrc}.svg`)} alt={token.fullName} width={24} height={24} />
    case 'fullName':
      return token.fullName
    case 'name':
      return token.name
    default:
      return null
  }
}
